function impl_toInt(a: number): number {
    return Math.floor(a);
}

function euclid(aRaw: number, bRaw: number): number {
    let a = impl_toInt(aRaw);
    let b = impl_toInt(bRaw);
    let q, r;
    while(b > 0) {
        q = impl_toInt(a/b);
        r = a % b;
        a = b;
        b = r;
    }
    return a;
}


export class MathUtils {

    static toInt(a: number): number {
        return  impl_toInt(a);
    }

    static GCD(aRaw: number, bRaw: number): number {
        return euclid(aRaw,bRaw);
    }

    static LCM(aRaw: number, bRaw: number): number {
        const a = MathUtils.toInt(aRaw);
        const b = MathUtils.toInt(bRaw);
        const gcd = MathUtils.GCD(a,b);
        return (a * b) / gcd;
        
    }

    static addThousandSepartor(num: number, separator: string): string {

        return `${num}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+separator)
    
    }
}
